const metaSelfInvest = {
    requiresAuth: true,
    roles: ['SelfInvest']
}


export default [
    {
        path: '/login',
        name: 'gestao-login',
        component: () => import('../views/Login.vue'),
        meta: { 
            requiresAuth: false,
            roles: []
        },
    },
    {
        path: '/gerencial/painel',
        name: 'Painel',
        component: () => import('../views/Gerencial/PainelSelfLayout.vue'),
        meta: metaSelfInvest,
    },
    {
        path: '/gerencial',
        name: 'Painel',
        component: () => import('../views/Gerencial/GerencialLayout.vue'),
        meta: metaSelfInvest,
        children: [
            {
                path: '/gerencial/operacoes/master',
                name: 'Operações Master',
                component: () => import('../components/Gerencial/Operacoes/index.vue'),
                meta: metaSelfInvest,
            },
            {
                path: '/gerencial/operacoes/gerar-ordem',
                name: 'Gerar ordem',
                component: () => import('../components/Gerencial/Operacoes/OperacaoOrdem/index.vue'),
                meta: metaSelfInvest,
            },
            {
                path: '/gerencial/operacoes/options-price',
                name: 'Options Price',
                component: () => import('../components/Gerencial/Operacoes/OptionsPrice/index.vue'),
                meta: metaSelfInvest,
            },
            {
                path: '/gerencial/operacoes/rascunho-ordens',
                name: 'Rascunho ordens',
                component: () => import('../components/Gerencial/Operacoes/RascunhoOrdem/index.vue'),
                meta: metaSelfInvest,
            },
            {
                path: '/gerencial/operacoes/cliente',
                name: 'Operações Cliente',
                component: () => import('../components/Gerencial/Operacoes/OperacoesCliente/index.vue'),
                meta: metaSelfInvest,
            },

            {
                path: '/gerencial/operacoes/acompanhar',
                name: 'Acompanhar Ordens',
                component: () => import('../components/Gerencial/Operacoes/AcompanharOrdens/index.vue'),
                meta: metaSelfInvest,
            },
            {
                path: '/gerencial/operacoes/acompanhar/:rid',
                name: 'Acompanhar Ordens - Detalhes',
                component: () => import('../components/Gerencial/Operacoes/AcompanharOrdens/DetalheOrdem/index.vue'),
                meta: metaSelfInvest,
            },
            {
                path: '/gerencial/operacoes/ativos-referencia',
                name: 'Ativos de Refência',
                component: () => import('../components/Gerencial/Operacoes/AtivosReferencia/index.vue'),
                meta: metaSelfInvest,
            },
            {
                path: '/gerencial/operacoes/simulacao-rolagem',
                name: 'Simulação Rolagem',
                component: () => import('../components/Gerencial/Operacoes/SimulacaoRolagem/index.vue'),
                meta: metaSelfInvest,
            },
        ] 
    },
    {
        path: '*',
        redirect: '/login'
    }
]